import API from './API';
var CreditTransferService = {
    getCreditTransfer: function (id, config) {
        return API.get("/credit_transfers/".concat(id), config);
    },
    getCreditTransfers: function (config) {
        return API.get('/credit_transfers', config);
    }
};
export default CreditTransferService;
